// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../../../components/library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uXabszAg6OmSg616RAhw {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    margin: 0;
}

.mdVKWgL2XKIlb1VnVDsp, .gsiiFbY00kwFB8feKVsL {
    margin-top: 4px;
    font-size: 16px;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]};
}

.gsiiFbY00kwFB8feKVsL {
    width: 100%;
    text-align: left;
    margin-bottom: 0;
}

.uZMaBGLZamYLN4xpr2Gv {
    border: 1px solid #E2E9FC;
    border-radius: 5px;
    height: 42px;
    padding: 0 4px;
    box-sizing: border-box;

    display: flex;
    align-items: center;
    justify-content: space-between;

    position: relative;

    transition: .3s;
}

.uZMaBGLZamYLN4xpr2Gv:focus-within {
    border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.uZMaBGLZamYLN4xpr2Gv input {
    border: none;
    outline: none;

    width: 100%;
    height: 100%;
    background: transparent;

    font-family: Roboto, sans-serif;
    font-style: normal;
}

.RU7oOaob0w_MSAzqx2ZB {
    position: absolute;
    top: 42px;
    left: -2px;
    z-index: 10;

    display: flex;
    flex-direction: column;
    align-items: center;

    width: 100%;
    padding: 4px;
    box-sizing: border-box;

    border-radius: 5px;
    box-shadow: 0 1px 15px #F5F8FD;

    background-color: white;
    border: 1px solid #E2E9FC;
}

.uZMaBGLZamYLN4xpr2Gv:hover {
    border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.f1sXFJ6N9lOHfwzaXO4G {
    width: 100%;
    height: 42px;
    margin-bottom: 0;
    text-align: left;
    transition: .3s;
}

.f1sXFJ6N9lOHfwzaXO4G:hover {
    background-color: #F8FAFF;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]};
}

.LWvsxUo3jja8mtyBpWuG {
    transition: .3s !important;
}

.WKAD4hlmrzqvqEmoEgUe {
    transform: rotate(-180deg) !important;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]} !important;
}

.P4jeTLnOilz6Mydos04r {
    margin-left: 4px;
}

.IGBqQGbBSKK83H6NU7Cg {
    border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]};
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]};
}

.IGBqQGbBSKK83H6NU7Cg p, .IGBqQGbBSKK83H6NU7Cg input, .FdKalsKz6wBoMjelCFFQ {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error-dark"]};
}

.LeJRo2Ye6fDrVdrZyoez {
    margin: 2px 0 0;
    font-size: 14px;
}

.gJjDB6rTYtdWCQBlpAcr {
    margin-top: 0;
    margin-bottom: 4px;
    font-size: 14px;
}

.KVmV4MtEa5eSMzb5IWwL {
    display: none;
}

.XYDpqsUKkHe31ixTMsH_ {
    display: block;
}

@media screen and (max-width: 425px) {
    .KVmV4MtEa5eSMzb5IWwL {
        display: block;
    }

    .XYDpqsUKkHe31ixTMsH_ {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./src/views/Investments/InvestmentsForm/InvestmentsFormDropdown/InvestmentsFormDropdown.module.css"],"names":[],"mappings":"AAGA;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,eAAe;IACf,eAAe;IACf,mDAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,sBAAsB;;IAEtB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;;IAE9B,kBAAkB;;IAElB,eAAe;AACnB;;AAEA;IACI,0DAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,aAAa;;IAEb,WAAW;IACX,YAAY;IACZ,uBAAuB;;IAEvB,+BAA+B;IAC/B,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;;IAEX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;;IAEnB,WAAW;IACX,YAAY;IACZ,sBAAsB;;IAEtB,kBAAkB;IAClB,8BAA8B;;IAE9B,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,0DAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,mDAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,qCAAqC;IACrC,8DAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0DAAyB;IACzB,mDAAkB;AACtB;;AAEA;IACI,mDAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["@value colors: \"components/library/style/colors.css\";\n@value color-purple, color-purple-bg, color-gray, color-text-subtle, color-error, color-error-dark from colors;\n\n.title {\n    font-family: Roboto, sans-serif;\n    font-style: normal;\n    font-weight: 500;\n    font-size: 16px;\n    margin: 0;\n}\n\n.description, .selection {\n    margin-top: 4px;\n    font-size: 16px;\n    color: color-text-subtle;\n}\n\n.selection {\n    width: 100%;\n    text-align: left;\n    margin-bottom: 0;\n}\n\n.input {\n    border: 1px solid #E2E9FC;\n    border-radius: 5px;\n    height: 42px;\n    padding: 0 4px;\n    box-sizing: border-box;\n\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    position: relative;\n\n    transition: .3s;\n}\n\n.input:focus-within {\n    border-color: color-purple;\n}\n\n.input input {\n    border: none;\n    outline: none;\n\n    width: 100%;\n    height: 100%;\n    background: transparent;\n\n    font-family: Roboto, sans-serif;\n    font-style: normal;\n}\n\n.dropdown {\n    position: absolute;\n    top: 42px;\n    left: -2px;\n    z-index: 10;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n\n    width: 100%;\n    padding: 4px;\n    box-sizing: border-box;\n\n    border-radius: 5px;\n    box-shadow: 0 1px 15px #F5F8FD;\n\n    background-color: white;\n    border: 1px solid #E2E9FC;\n}\n\n.input:hover {\n    border-color: color-purple;\n}\n\n.button {\n    width: 100%;\n    height: 42px;\n    margin-bottom: 0;\n    text-align: left;\n    transition: .3s;\n}\n\n.button:hover {\n    background-color: #F8FAFF;\n    color: color-purple;\n}\n\n.arrow {\n    transition: .3s !important;\n}\n\n.open {\n    transform: rotate(-180deg) !important;\n    color: color-purple !important;\n}\n\n.euro {\n    margin-left: 4px;\n}\n\n.error {\n    border-color: color-error;\n    color: color-error;\n}\n\n.error p, .error input, .warning {\n    color: color-error-dark;\n}\n\n.hint {\n    margin: 2px 0 0;\n    font-size: 14px;\n}\n\n.pea {\n    margin-top: 0;\n    margin-bottom: 4px;\n    font-size: 14px;\n}\n\n.mobile {\n    display: none;\n}\n\n.desktop {\n    display: block;\n}\n\n@media screen and (max-width: 425px) {\n    .mobile {\n        display: block;\n    }\n\n    .desktop {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"components/library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple"]}`,
	"color-purple-bg": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-purple-bg"]}`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-text-subtle"]}`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}`,
	"color-error-dark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error-dark"]}`,
	"title": `uXabszAg6OmSg616RAhw`,
	"description": `mdVKWgL2XKIlb1VnVDsp`,
	"selection": `gsiiFbY00kwFB8feKVsL`,
	"input": `uZMaBGLZamYLN4xpr2Gv`,
	"dropdown": `RU7oOaob0w_MSAzqx2ZB`,
	"button": `f1sXFJ6N9lOHfwzaXO4G`,
	"arrow": `LWvsxUo3jja8mtyBpWuG`,
	"open": `WKAD4hlmrzqvqEmoEgUe`,
	"euro": `P4jeTLnOilz6Mydos04r`,
	"error": `IGBqQGbBSKK83H6NU7Cg`,
	"warning": `FdKalsKz6wBoMjelCFFQ`,
	"hint": `LeJRo2Ye6fDrVdrZyoez`,
	"pea": `gJjDB6rTYtdWCQBlpAcr`,
	"mobile": `KVmV4MtEa5eSMzb5IWwL`,
	"desktop": `XYDpqsUKkHe31ixTMsH_`
};
export default ___CSS_LOADER_EXPORT___;
